import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=67e1b8f0&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OrderItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=67e1b8f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1b8f0",
  null
  
)

export default component.exports